import type { FunctionComponent } from 'react'

import {
	BaseCheckBox,
	BodySStrong,
	CaptionS,
	COLORS,
	SPACING,
} from '@monthio/design-system'
import { CurrencyDisplay, DateTime } from '@monthio/react-components'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

const TransactionListItemContainer = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: space-between;
	align-items: center;
	padding: ${SPACING.s} ${SPACING.m};
	border-bottom: 1px solid ${COLORS.graphics.stroke.primary};
	gap: ${SPACING.xs};
	&:last-child {
		border-bottom: none;
	}
`

export const TransactionListContainer = styled.div`
	display: flex;
	flex-direction: column;
	background: ${COLORS.interactives.input.subtleSelect.defaultSurface};
	border-top: 1px solid ${COLORS.graphics.stroke.primary};
`

const TransactionNameAndDateContainer = styled.div`
	display: flex;
	flex-direction: column;
`

const CheckBoxContainer = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: ${SPACING.xs};
	label > div:nth-of-type(2) {
		display: block;
	}
`

// TODO: Check design with overlap of Label styles
const Label = styled(BodySStrong)`
	font-weight: 600;
	margin: 0px;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
	overflow: hidden;
	text-overflow: ellipsis;
`

const DateLabel = styled(CaptionS)`
	margin: 0px;
`

// TODO: Check design with overlap of Label styles
const Amount = styled(BodySStrong)`
	font-weight: 600;
	margin: 0px;
`

interface TransactionListItemProps {
	transactionId: string
	text: string
	date: string
	amount: number
	isSelected: boolean
	onSelect: (transactionId: string, selected: boolean) => void
}

export const TransactionListItem: FunctionComponent<
	TransactionListItemProps
> = ({ transactionId, text, date, amount, isSelected, onSelect }) => {
	const { t } = useTranslation()

	return (
		<TransactionListItemContainer
			onClick={() => onSelect(transactionId, !isSelected)}
		>
			<CheckBoxContainer>
				<BaseCheckBox
					isSelected={isSelected}
					size="m"
					aria-label={t(
						'savingsCapacity-transactionListItem-selected-transaction',
						{
							transaction: text,
						},
					)}
				/>
				<TransactionNameAndDateContainer>
					<Label>{text}</Label>
					<DateLabel>
						<DateTime date={date.toString()} format="short" showYear />
					</DateLabel>
				</TransactionNameAndDateContainer>
			</CheckBoxContainer>

			<Amount>
				<CurrencyDisplay amount={Math.abs(amount)} />
			</Amount>
		</TransactionListItemContainer>
	)
}
